export default function BillReviseTab() {
  return <p>Bill Revise Content</p>;
}
